var geocoder;
var map;
var article;
var address;

function initMap() {
	geocoder = new google.maps.Geocoder();

	var article = document.getElementById('address');	
	if ( article ) {
		var addrArr = [article.dataset.street, article.dataset.city, article.dataset.province, article.dataset.zip];
		var tooltip = article.dataset.name;
		address = addrArr.join(', ');
		codeAddress( address );
	}
}

function codeAddress(address) {
	
    geocoder.geocode( { 'address': address}, function(results, status) {
      if (status == 'OK') {
		var coord = results[0].geometry.location;
		var map = new google.maps.Map(
			document.getElementById('map'), {zoom: 16, center: coord});
        var marker = new google.maps.Marker({
            map: map,
            position: coord,
            animation: google.maps.Animation.DROP
        });
      } else {
        alert('Geocode was not successful for the following reason: ' + status);
      }
    });
}